<template>
  <div>
    <div class="card">
      <div class="card-title border-bottom p-3 mb-0 header-title">
        {{$t('common.upload_resume.steps.step3.working_experience')}}
        <a href="#"
          @click="show = true"
          class="btn btn-primary btn-sm btn-rounded float-right">
          <i class="uil-plus"></i>
        </a>
      </div>
      <div class="card-body">
        <VuePerfectScrollbar style="max-height: 300px">
          <div class="text-center"
            v-if="model.work_experiences.length == 0"
          >{{$t('common.upload_resume.steps.step3.empty_working_experience')}}.</div>

          <div class="list-group" 
            v-for="item in model.work_experiences"
            :key="`item-${item.uiid}`"
          >
            <div class="list-group-item mb-2">
              <div>
                <h5 class="font-size-15 m-0">{{ item.position }}
                  <a href="#"
                    @click="editExperience( item.uiid )"
                    class="btn btn-primary btn-sm btn-rounded float-right">
                    <i class="uil-pen"></i>
                  </a>
                </h5>
                <p class="m-0">{{ item.company }} <span class="text-muted">{{ item.employment_type | capitalize  }}</span></p>
                <p class="text-muted mb-1">{{ item.start_month | capitalize  }} {{ item.start_year }} - {{ (item.present == true ? "Present" : item.end_month) | capitalize }} {{ item.present == true ? "" : item.end_year }}</p>
                <VuePerfectScrollbar style="max-height: 200px;    white-space: pre-wrap;">
                  <p class="sub-header" v-html="item.description"></p>
                </VuePerfectScrollbar>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
    </div>
    <b-modal 
      v-model="show" 
      ref="work_experience"
      size="lg" 
      :title="(work_experience.uiid ? $t('common.edit') : $t('common.add')) + ' ' + $t('common.upload_resume.steps.step3.working_experience')" 
      title-class="font-18">
      <div class="row">
        <div class="col-md-12">
          <TextField 
            :placeholder="$t('common.upload_resume.steps.step3.window_experience.position.placeholder')"
            :label="$t('common.upload_resume.steps.step3.window_experience.position.label')"
            v-model="work_experience.position"
          />
          <DropDown 
            :label="$t('common.upload_resume.steps.step3.window_experience.type.label')"
            :options="employment_type_options"
            :name.sync="work_experience.employment_type"
            v-model="work_experience.employment_type"
          />
          <TextField 
            :placeholder="$t('common.upload_resume.steps.step3.window_experience.company.placeholder')"
            :label="$t('common.upload_resume.steps.step3.window_experience.company.label')"
            v-model="work_experience.company"
          />
          <TextField 
            :placeholder="$t('common.upload_resume.steps.step3.window_experience.country.placeholder')"
            :label="$t('common.upload_resume.steps.step3.window_experience.country.label')"
            v-model="work_experience.country"
          />
          <b-form-checkbox
            v-model="work_experience.present"
            class="mb-2">
            I am currently working here
          </b-form-checkbox>
          <div class="row">
            <DropDown 
              :label="$t('common.upload_resume.steps.step3.window_experience.start_month.label')"
              class="col-md-3"
              :options="month_options"
              :name.sync="work_experience.start_month"
              v-model="work_experience.start_month"
            />
            <TextField 
              type="number"
              :placeholder="$t('common.upload_resume.steps.step3.window_experience.start_year.placeholder')"
              :label="$t('common.upload_resume.steps.step3.window_experience.start_year.label')"
              class="col-md-3"
              v-model="work_experience.start_year"
            />
            <DropDown 
              :label="$t('common.upload_resume.steps.step3.window_experience.end_month.label')"
              class="col-md-3"
              :options="month_options"
              :name.sync="work_experience.end_month"
              v-model="work_experience.end_month"
              v-if="!work_experience.present"
            />
            <TextField 
              type="number"
              :placeholder="$t('common.upload_resume.steps.step3.window_experience.end_year.placeholder')"
              :label="$t('common.upload_resume.steps.step3.window_experience.end_year.label')"
              class="col-md-3"
              v-model="work_experience.end_year"
              v-if="!work_experience.present"
            />
          </div>
          <textarea class="form-control" rows="7"
           v-model="work_experience.description"
          ></textarea>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="danger" v-if="work_experience.uiid" @click="removeExperience">Remove</b-button>
        <b-button variant="light" @click="show = false">Close</b-button>
        <b-button variant="primary" @click="addExperience">{{ ( work_experience.uiid ? 'Update' : 'Add') + ' Experience' }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import  FormMixin from '@mixins/form'
import NProgress from 'nprogress/nprogress'
import TextField from '@components/form/textfield.vue'
import DropDown from '@components/form/dropdown.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  mixins: [FormMixin],
  data(){
    return {
      model:{
        work_experiences:[],
      },
      show:false,
      work_experience:{},
      employment_type_options: [
        { value: null, text: '-' },
        { value: 'full-time', text: 'Full-time' },
        { value: 'permanent', text: 'Permenent' },
        { value: 'volunteer', text: 'Volunteer' },
        { value: 'part-time', text: 'Part-time' },
        { value: 'self-employed', text: 'Self-employed' },
        { value: 'freelance', text: 'Freelance' },
        { value: 'contract', text: 'Contract' },
        { value: 'intership', text: 'Internship' }
      ],
      month_options : [
        { value: null, text: '-' },
        {value:'january', text:'January'},
        {value:'february', text:'February'},
        {value:'march', text:'March'},
        {value:'april', text:'April'},
        {value:'may', text:'May'},
        {value:'june', text:'June'},
        {value:'july', text:'July'},
        {value:'august', text:'August'},
        {value:'september', text:'September'},
        {value:'october', text:'October'},
        {value:'november', text:'November'},
        {value:'december', text:'December'}
      ],
      fullWidth:document.getElementsByClassName('content-page').item(0).clientWidth
    }
  },
  components:{TextField, DropDown, VuePerfectScrollbar},
  mounted(){
   /*  window.addEventListener('resize', this.handleResize) */
  },
  methods: {
    ...mapActions('prospect', [
      'createWorkingExperience', 
      'removeWorkingExperience',
      'updateWorkingExperience',
    ]),
    async validate() {
      var isValid = true

      
      this.$emit('on-validate', null, isValid)
      return isValid
    },
    addExperience(){
      delete this.work_experience._idx
      NProgress.start()
      if(!this.work_experience.uiid){
        this.work_experience.candidate_id = this.$route.query.id
        this.createWorkingExperience(this.work_experience).then(res => {
          this.model.work_experiences.push(res.data)
          NProgress.done()
        })
      }else{
        this.updateWorkingExperience(this.work_experience).then(res => {
          this.work_experience = res;
          NProgress.done()
        })
      }
      this.work_experience = {}
      this.show = false
    },
    editExperience(uiid){
      this.model.work_experiences.forEach((el, idx) => {
        if(el.uiid == uiid){
          this.work_experience = el
          this.work_experience._idx = idx
          //this.model.work_experiences.splice(idx, 1)
        }
        return false
      });
      this.$refs['work_experience'].show()
    },
    removeExperience(uiid){
      if(!this.work_experience.uiid){
        this.model.work_experiences.forEach((el, idx) => {
          if(el.uiid == uiid){
            this.work_experience = el
            this.work_experience._idx = idx
            //this.model.work_experiences.splice(idx, 1)
          }
          return false
        });
      }
      this.removeWorkingExperience(this.model.work_experiences[this.work_experience._idx]).then(res => {
        if(res.data.ok == 1){
          this.model.work_experiences.splice(this.work_experience._idx, 1)
          this.work_experience = {}
          this.$refs['work_experience'].hide()
        }else{
          alert('Please try again')
        }
      })
    }
  },
  props:['data'],
  watch: { 
    data: function(newVal) { // watch it
      this.model.work_experiences = newVal
    }
  }
}
</script>